module.exports = __webpack_public_path__ + "static/media/moglix-logo.05a3eb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/billing-icons/moglix-logo.png
// module id = 1272
// module chunks = 17